<div *ngIf="isLoading" class="spinner-container" [ngClass]="'main'">
    <div class="loading-ring" [ngClass]="size">
        <div [ngClass]="'main'" [class]="size"></div>
    </div>
</div>
